var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1128.88 1128.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M491.68 5.19c-182.08,27.63 -275.12,102.89 -362.86,199.5 -81.57,89.81 -147.85,266.48 -123.85,433.2 45.87,318.46 332.57,528.17 633.12,485.39 461.86,-65.73 680.27,-636.01 285.86,-995.07 -100.9,-91.86 -284.29,-145.48 -432.27,-123.02zm7.09 48.73c-124.89,19.56 -258.59,81.09 -332.96,183.16 -74.81,102.69 -136.51,225.13 -112,395.4 17.77,123.46 87.03,258.73 183.82,329.64 117.43,86.02 234.66,134.44 395.03,112.28 258.02,-35.66 484.19,-271.24 441.9,-578.81 -39.26,-285.62 -307.56,-483.67 -575.79,-441.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M509.48 834.56l-43.43 0.37 0.04 46.6 196.2 1.58 0 -46.77 -43.4 -1.78c-9.56,-8.36 -5.4,14.08 -8.81,-18.03l4.05 -348.8 -146.25 0 0 44.96 46.38 1.4c9.2,28.21 3.51,127.84 3.51,164.1l0.18 142.92c-3.72,19.57 2.73,8.48 -8.47,13.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M543.99 223.98c-91.19,28.15 -56.23,168.13 42.9,139.8 89.4,-25.54 49.31,-168.26 -42.9,-139.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.ed77209872ee5ab6a3e26b5c96b994f0.svg";
export { ForwardRef as ReactComponent };